import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import EventTracking from 'lib/EventTracking';
import Link from 'components/Link.jsx';
import MessageInterfacePropType from 'chat/lib/MessageInterfacePropType';
import MessageItemAttachment from './MessageItemAttachment.jsx';
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';
import TranslatableText from 'chat/components/TranslatableText.jsx';

import './styles/MessageItemContent.scss';

const UI_CONTEXT = 'chat_message';

class MessageItemContent extends React.Component {
  static propTypes = {
    sentBySelf: React.PropTypes.bool.isRequired,
    message: MessageInterfacePropType.isRequired,
    failed: React.PropTypes.bool,
  };

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      language: this.props.message.getISO639Locale(),
    };
  }

  /* Translate the message.
   * Toogles the language between the message locale & the user locale.
   */
  translate = (): void => {
    const shouldTranslateToMessageLocal = (
      this.state.language === this.props.message.getISO639Locale()
    );

    const language = shouldTranslateToMessageLocal ?
      CurrentUser.getUser().getISO639Locale() :
      this.props.message.getISO639Locale();

    this.setState({ language });

    const elementName = shouldTranslateToMessageLocal ?
      'translation_show_translation' :
      'translation_show_orignal';

    EventTracking.tap(this.context.eventScreenName, elementName, UI_CONTEXT);
  };

  isMessageTranslatable(): boolean {
    return !!(
      // a user is signed in
      CurrentUser.isSignedIn() &&
      // current user was not the sender
      this.props.message.getSender().id !== CurrentUser.getUserId() &&
      // the locales are defined on the user & the message
      CurrentUser.getUser().getISO639Locale() && this.props.message.getISO639Locale() &&
      // the locales differs from one another.
      this.props.message.getISO639Locale() !== CurrentUser.getUser().getISO639Locale()
    );
  }

  renderMessageAttachment() {
    const { message } = this.props;
    const file = message.getFile();
    if (!file) {
      return null;
    }
    return <MessageItemAttachment file={file} />;
  }

  renderMessageBody() {
    const { message } = this.props;
    const body = message.getBody();
    if (!body) {
      return null;
    }

    let messageBody = this.isMessageTranslatable() ?
      <TranslatableText
        text={body}
        language={this.state.language}
      /> :
      <TextWithEntities
        text={body}
        entities={
          [].concat(
            TextEntities.parseEmoji(body),
            TextEntities.parseShortcodeEmoji(body),
            TextEntities.parseNewlines(body),
            TextEntities.parseLeadingWhitespace(body),
            TextEntities.parseUrls(body)
          )
        }
        shallow
      />;

    if (this.isMessageTranslatable()) {
      // BUG messageBody may have a URL transformed to a Link,
      // which causes a validateDOMNesting <a> error
      messageBody = (
        <Link
          color="inherit"
          onClick={this.translate}
          className="MessageItem-Translatable"
          eventElementName="MessageItem-Translatable">
          {messageBody}
        </Link>
      );
    }

    return (
      <div
        className={cx('MessageItemContent-body', {
          'MessageItemContent-failedBody': this.props.failed,
        })}>
        {messageBody}
      </div>
    );
  }

  render() {
    return (
      <div
        className={cx(this.props.className, {
          'MessageItemContent-self': this.props.sentBySelf,
        })}>
        {this.renderMessageBody()}
        {this.renderMessageAttachment()}
      </div>
    );
  }
}

export default MessageItemContent;



// WEBPACK FOOTER //
// ./src/chat/components/MessageItemContent.jsx